import type React from 'react';
import { twMerge } from 'tailwind-merge';

import { type CommonProps, Stack, type StackProps } from 'gooey';

export type PageProps = React.PropsWithChildren<
  {
    /**
     * Additional classes to apply to the page.
     */
    className?: string;
    /**
     * The amount of space to add to the top/bottom of the page. If you pass in a ResponsiveStyleValue object,
     * it will be used in place of the default spacing.
     */
    gutter?: StackProps['spacing'];
    /**
     * Inject content before the main content.
     */
    preContent?: React.ReactNode;
    /**
     * Inject content after the main content.
     */
    postContent?: React.ReactNode;
  } & CommonProps
>;

export function Page({
  className,
  gutter = defaultGutter,
  children,
  preContent,
  postContent,
  style,
}: PageProps) {
  return (
    <Stack className={twMerge('quark-page min-h-[60vh]', className)} spacing={gutter} style={style}>
      <div />
      {preContent}
      <main>
        <Stack className={twMerge('quark-page-inner z-10')} alignItems='center' spacing={0}>
          {children}
        </Stack>
      </main>
      {postContent}
      <div />
    </Stack>
  );
}

/*
|------------------
| Internals
|------------------
*/

const defaultGutter = {
  xs: 6,
  sm: 8,
  md: 12,
};
